import type { ConversationMessage } from '@chatbot/shared-types';

/**
 * Si el texto del mensaje sobra cuando hay un archivo que se puede mostrar.
 *
 * El texto que guarda el turno para un medio es un reemplazo —`[audio]`,
 * `[image]`— pensado para cuando NO se puede mostrar el archivo: en la vista
 * previa de la lista, o cuando el archivo expiró. Con el reproductor a la vista
 * es ruido: dice en palabras lo que el control ya muestra.
 *
 * Sólo se oculta si el archivo **se puede abrir**. Sin `url`, el texto es lo
 * único que le dice al operador que la persona mandó algo.
 */
export function ocultarTextoDeReemplazo(message: ConversationMessage): boolean {
  if (!message.medio?.url) return false;
  return /^\[[a-z_]+\]$/i.test(message.text.trim());
}
